<div
  class="component-container text-cool-grey
        overflow-y-auto overscroll-y-auto
        flex flex-col justify-center
        items-center  xs:p-[1.5rem] min-h-full"
>
  <app-step-progress-indicator
    [currentStep]="5"
    [totalSteps]="5"
  ></app-step-progress-indicator>
  <ng-template formHost></ng-template>
</div>
